import { types as layoutTypes } from './layout';
import { types as lineTypes } from './salesorderLines';
import { findIndex, sum } from 'lodash';
import svc from 'svc';



export const types = {
	SET_STATE: 'SALESORDERS/SET_STATE',
	RESET_ALL: 'SALESORDERS/RESET_ALL',
};

/* LINE SAMPLE
 Item: '1095AF-02', //*
 Key: 0,
 Qty: 1, //*
 UnitPrice: 133.7, //*
 Price: 13.37, //*
 PriceAfterVat: 133.7, //*
 TaxCode: 'EX', //*
 //...Optional...
 Description: 'Its cool',
 DiscountByPercent: 5
 */

export const initialState = {
	mode: 'list',
	pageError: false,
	activeRow: null,
	hasChanged: false,
	isQuote: false,
	isDraft: false,
	quoteSubMenu: 'general',
	paymentSubMenu: 'stored',
	showItemsDialog: false,
	showSaveDialog: false,
	showForcedDraftDialog: false,
	showPrintDialog: false,
	showPrintDialogOnLoad: false,
	showSlowPokeDialog: false,
	saveErrors: null,
	skipPayment: false,
	selectedItems: [],
	loadingOrder: false,
	DocEntry: null,
	cardCode: null,
	recentOrders: null,
	recentQuotes: null,
	itemSearch: '',
	pendingSave: false,
	pendingPayment: false,
	submitAction: 'save',
	history: [],
	imageColumns: [
		'U_Approval_DATA',
		'U_DFO_DATA',
		'U_CustArtWork_DATA',
		'U_DesignerArtWwork_DATA',
		'U_VendorArtWork_DATA',
	],
	order: {
		CardCode: '',
		CardName: '',
		ContactName: '',
		PostingDate: getDate(),
		DueDate: getDate(),
		DocumentDate: getDate(),
		DocNum: '',
		SalesEmployeeCode: -1, // Optional
		Reference: '',
		GroupNum: '',
		Remarks: '',
		Printed: 'N',
		Status: 'O',
		ShipTo: '',
		BillTo: '',
		ActualShipTo: '',
		ActualBillTo: '',
		TaxCode: 'UPDATE',
		GrossProfit: 'Save to calculate',
		DocTotal: 0,
		DiscountByPercent: 0,
		DiscountTotal: 0,
		DiscountByAmount: 0,
		Header: '',
		Footer: '',
		totalBeforeLineDiscounts: 0,
		totalAfterLineDiscounts: 0,
		taxAmount: 0,
		U_ContactEmail: '',
		// New stuff
		U_SaleType: 'E', // Dropdown
		U_DiscountType: '', // Dropdown
		U_Contest: '', // Dropdown
		U_CCLast: '',
		U_SenderInfo: '',
		U_POSent: '1', // Dropdown
		U_Approval: '', // Art
		U_SalesRepComm: 'Y', // Dropdown
		U_CustomRedo: '0', // Dropdown
		U_NBS_CC1: '',
		U_NBS_CC2: '',
		U_NBS_CC3: '',
		U_NBS_CC4: '',
		U_NBS_CC5: '',
		U_FreightType: '', // Dropdown
		U_DocRef: '',
		U_FreightAmt: 0,
		U_SalesRep: '', // Dropdown
		U_PaidFreight: '', // Dropdown
		U_ChgBackCust: '', // Dropdown
		U_ChgBackVendor: '', // Dropdown
		U_DealerCoordinator: '',
		U_DealerCoorPhone: '',
		U_DealerCoorEmail: '',
		U_DFO: '', // art
		U_SpecialEvent: '', // Dropdown
		U_NBS_RAMNum: '',
		U_RD1_RecInv: 0,
		U_RD1_Sch: 0,
		U_NBS_Recurring: 'N', // Dropdown
		U_NBS_Defer: 'N', // Dropdown,
		U_NBS_FreeShip: 0,
		U_NBS_CmpDisc: '',
		U_NBS_CmpgnCode: '',
		U_NBS_CmpStDte: '', // Date
		U_NBS_CmpEdDte: '', // Date
		U_NBS_CmpDiscAmt: 0,
		U_NBS_CmpFreeShip: 'N', // Dropdown
		U_NBS_ShipAmt: 0,
		U_TRC_ConsSt: '',
		U_LinkedPO: '',
		U_PRX_SID: '',
		U_PRX_TkNo: '',
		U_PRX_SRVR: '',
		U_ShipName: '',
		U_Street: '',
		U_Block: '',
		U_City: '',
		U_ZipCode: '',
		U_County: '',
		U_State: '',
		U_Country: '',
		U_A_PAYT: '',
		U_A_CCEV: '',
		U_A_CCUID: '',
		U_NBS_GatewayDesc: '', // Dropdown, table NBS_MULTIGATEWAYS
		U_NBS_PayChgAmt: 0,
		U_WebSrc: '', // Dropdown
		U_PRX_PAYM: '',
		U_AdjType: '', // Dropdown
		U_CouponCode: '',
		U_FrameQuote: '',
		U_ClosingMonth: '6', // Dropdown
		U_POType: 'Empty', // Dropdown
		U_TrackingNo: '',
		U_WriteOff: 'N',
		U_AltSalesEmployee: '', // Dropdown, table ALT_SALES_EMPLOYEE
		U_PurchaseAlert: 'N', // Dropdown
		U_ComNum: 0,
		U_StitchCount: '',
		U_Cancel_Reason: 'Blank', // Dropdown
		U_Imprint_Location: '',
		U_Dec_Color: '',
		U_Thread_Color: '',
		U_Dec_Notes: '',
		U_DpmtRequired: 'Y', // Dropdown
		U_PmtStatus: '', // Dropdown
		U_SuggestedArt: 'NA', // Dropdown
		U_CustArtWork: '',
		U_DesignerArtWwork: '',
		U_VendorArtWork: '',
		U_GenVen: '',
		U_TSPayflowID: '',
		attnShip: '',
		attnBill: '',
		CANCELED: 'N',
	},
	quoteUDFs: {
		U_FrameCopyT: '',
		U_FrameCopyB: '',
		U_FrameCopyS: '',
		U_FrameHoles: 'NA',
		U_FrameColor: 'NA',
		U_FrameStyle: 'NA',
		U_FrameImprint: '',
		U_FrameImprint2: '',
		U_FrameNotes: '',
		U_FobCopyF: '',
		U_FobCopyB: '',
		U_FobNotes: '',
		U_FobColor: 'NA',
		U_FobShape: 'NA',
		U_FobImprint1: 'NA',
		U_FobImprint2: 'NA',
		U_FobImprint3: 'NA',
		U_FobImprint4: 'NA',
		U_FobPosRev1: 'NA',
		U_FobSide: 'NA',
		U_DecalType: 'NA',
		U_DecalStyle: 'NA',
		U_DecalImprint1: 'NA',
		U_DecalImprint2: 'NA',
		U_DecalImprint3: 'NA',
		U_DecalPosRev1: 'NA',
		U_DieCutColors: 'NA',
		U_DieCutScreen: 'NA',
		U_DieCutSize: '',
		U_DecalCopy: '',
		U_DecalNotes: '',
		U_DomeSize: 'NA',
		U_DomeMat: 'NA',
		U_DomeColor: 'NA',
		U_DomeImprint1: 'NA',
		U_DomeImprint2: 'NA',
		U_DomeImprint3: 'NA',
		U_DomeBleed1: 'NA',
		U_DomPosRev1: 'NA',
		U_DomeCopy: '',
		U_DomeNotes: '',
		U_GenSize: '',
		U_GenImprint: '',
		U_GenDesc: '',
		U_GenCopy: '',
		U_GenNotes: '',
		U_OrderType: 'N',
		U_PriorOrder: '',
		U_ComType: 'NA',
		U_Coordinator: '',
		U_QuoteStatus: '1',
		U_Designer: '',
		U_SenderInfo: '',
		U_PlateCopyC: '',
		U_PlateCopyT: '',
		U_PlateCopyB: '',
		U_PlateNotes: '',
		U_PlateUse: '',
		U_PlateHole: '',
		U_PlateBorder: '',
		U_PosRev1: '',
		U_PlateBleed1: '',
		U_PlateImprint3: '',
		U_PlateImprint2: '',
		U_PlateImprint1: '',
		U_PlateColorA: '',
		U_PlateColor: '',
		U_DieCutSizeStrict: '',
	},
	freight: {
		"1": {
			FreightCode: "1",
			LineTotal: 0,
			TaxCode: "EX",
		},
		"6": {
			FreightCode: "6",
			LineTotal: 0,
			TaxCode: "EX",
		},
		"7": {
			FreightCode: "7",
			LineTotal: 0,
			TaxCode: "EX",
		},
		"8": {
			FreightCode: "8",
			LineTotal: 0,
			TaxCode: "EX",
		},
		"9": {
			FreightCode: "9",
			LineTotal: 0,
			TaxCode: "EX",
		},
		"10": {
			FreightCode: "10",
			LineTotal: 0,
			TaxCode: "EX",
		},
		"12": {
			FreightCode: "12",
			LineTotal: 0,
			TaxCode: "EX",
		},
	},
	showFreightExtras: 'N',
	deletedLines: [],
	paymentTermCardOverrides: [ 1, 2, 3, 4, 5, "1", "2", "3", "4", "5" ],
	payments: [],
	warehouses: [ '100', '125', '250' ],
};


export default (state = initialState, action) => {
	switch ( action.type ) {
		case types.SET_STATE:
			return { ...state, ...action.data };
		case types.RESET_ALL:
			return { ...initialState };
		default:
			return state;
	}
}

export const actions = {
	setState: (data) => ({
		type: types.SET_STATE,
		data,
	}),


	updateChanged: () => ({
		type: types.SET_STATE,
		data: { hasChanged: true },
	}),


	resetAll: () => {
		return (dispatch, getState) => {
			dispatch({ type: types.RESET_ALL });
			let state = getState();
			let freightTypes = state.appData.FreightTypes;
			let freight = {};

			for ( let code in freightTypes ) {
				freight[ code ] = {
					FreightCode: code,
					LineTotal: 0,
					TaxCode: 'UPDATE',
				}
			}

			dispatch({
				type: types.SET_STATE,
				data: { freight },
			});
		}
	},

	setAddress: (type, data) => {
		return (dispatch, getState) => {
			let state = getState();
			let pre = type === 'shipping' ? 'Ship' : 'Bill';
			//let attnCol = type === 'shipping' ? 'attnShip' : 'attnBill';
			let so = state.salesOrders;
			let taxCode = state.salesOrders.order.TaxCode || 'UPDATE';
			if ( data && data.TaxCode && type === 'shipping' ) {
				taxCode = data.TaxCode || 'UPDATE';
			}

			let update = {
				order: {
					...so.order,
					TaxCode: taxCode,
				},
				freight: { ...so.freight },
			};

			if ( !data ) {
				update.order[ `${pre}To` ] = '';
				delete(update.order[ `${pre}Street` ]);
				delete(update.order[ `${pre}Block` ]);
				delete(update.order[ `${pre}Zip` ]);
				delete(update.order[ `${pre}City` ]);
				delete(update.order[ `${pre}StateCode` ]);
				delete(update.order[ `${pre}CountryCode` ]);

				if ( type === 'shipping' ) {
					for ( let key in update.freight ) {
						update.freight[ key ].TaxCode = taxCode;
					}
				}

				let lines = state.salesorderLines.map(line => {
					// DI won't let us update kit component tax codes
					if ( !line.removable && (line.Key || line.Key === 0 || line.Key === '0') ) return line;
					return {
						...line,
						TaxCode: taxCode,
					};
				});
				dispatch({
					type: lineTypes.REPLACE_STATE,
					data: lines,
				});
				dispatch({
					type: types.SET_STATE,
					data: update,
				});
				dispatch(actions.updateTotals());
				//dispatch({ type: lineTypes.REPLACE_STATE, data: lines});
				return true;
			}

			if ( data.ID ) {
				update.order[ `${pre}To` ] = data.ID;
			}

			if ( data.Street ) {
				update.order[ `${pre}Street` ] = `${data.Street}`;
			}

			if ( data.Block ) {
				update.order[ `${pre}Block` ] = data.Block;
			}

			if ( data.Zip ) {
				update.order[ `${pre}Zip` ] = data.Zip;
			}

			if ( data.City ) {
				update.order[ `${pre}City` ] = data.City;
			}

			if ( data.State ) {
				update.order[ `${pre}StateCode` ] = data.State;
			}

			if ( data.Country ) {
				update.order[ `${pre}CountryCode` ] = data.Country;
			}

			if ( type === 'shipping' ) {
				let taxCode = data.TaxCode ? data.TaxCode : 'UPDATE';
				for ( let key in so.freight ) {
					update.freight[ key ].TaxCode = taxCode;
				}

				let lines = state.salesorderLines.map(line => {
					// DI won't let us update kit component tax codes
					if ( !line.removable && (line.Key || line.Key === 0 || line.Key === '0') ) return line;
					return {
						...line,
						TaxCode: taxCode,
					};
				});
				dispatch({
					type: lineTypes.REPLACE_STATE,
					data: lines,
				});

			}

			dispatch({
				type: types.SET_STATE,
				data: update,
			});
			dispatch(actions.updateTotals());
		};
	},


	getHistory: (cardCode, orderType) => {
		return (dispatch) => {
			svc.send('salesorder', {
				method: 'getHistory',
				cardCode,
				orderType,
			}).then(res => {
				dispatch({
					type: types.SET_STATE,
					data: { history: res.payload.data },
				});
			}).catch(err => {
				dispatch({
					type: layoutTypes.NOTIFY,
					text: 'Error retrieving history data.',
				});
			});
		};
	},


	getPayments: (cardCode, docEntry, isDraft) => {
		return (dispatch) => {
			svc.send('salesorder', {
				method: 'getPayments',
				cardCode,
				docEntry,
				isDraft,
			}).then(res => {
				dispatch({
					type: types.SET_STATE,
					data: { payments: res.payload.data },
				});
			}).catch(err => {
				dispatch({
					type: layoutTypes.NOTIFY,
					text: 'Error retrieving payment data.',
				});
			});
		};
	},


	cancelOrder: (cardCode, docEntry, isQuote, isDraft) => {
		return (dispatch) => {
			dispatch({
				type: types.SET_STATE,
				data: { pendingSave: true },
			});

			svc.send('salesorder', {
				method: 'cancel',
				docEntry,
				isQuote,
				isDraft,
			}).then(res => {
				dispatch({
					type: types.SET_STATE,
					data: { pendingSave: false },
				});

				if ( isQuote ) {
					dispatch(actions.loadQuote(cardCode, docEntry, isDraft));
				} else {
					dispatch(actions.loadOrder(cardCode, docEntry, isDraft));
				}
			}).catch(err => {
				dispatch({
					type: types.SET_STATE,
					data: { pendingSave: false },
				});
				dispatch({
					type: layoutTypes.NOTIFY,
					text: err.msg,
				});
			});
		};
	},


	closeAndCopy: (cardCode, docEntry) => {
		return (dispatch) => {
			dispatch({
				type: types.SET_STATE,
				data: { pendingSave: true },
			});

			svc.send('salesorder', {
				method: 'convertDraft',
				docEntry,
				isQuote: false,
				isDraft: true,
			}).then(res => {
				dispatch({
					type: types.SET_STATE,
					data: { pendingSave: false },
				});
				dispatch({
					type: layoutTypes.NOTIFY,
					text: 'Draft converted to order.',
				});
				dispatch(actions.loadOrder(cardCode, res.payload.Key, false));
			}).catch(err => {
				dispatch({
					type: types.SET_STATE,
					data: { pendingSave: false },
				});
				dispatch({
					type: layoutTypes.NOTIFY,
					text: err.msg,
				});
			});
		};
	},


	loadOrder: (cardCode, docEntry, isDraft = false) => {
		return (dispatch, getState) => {
			let fullState = getState();
			let state = fullState.salesOrders;
			//let appData = fullState.appData;

			let newState = {
				...initialState,
				mode: state.mode,
				isQuote: state.isQuote,
				isDraft: state.isDraft,
				loadingOrder: true,
				DocEntry: state.DocEntry,
				cardCode: state.cardCode,
			};

			dispatch({
				type: types.SET_STATE,
				data: newState,
			});
			dispatch({ type: lineTypes.RESET_ALL });

			svc.send('salesorder', {
				method: 'load',
				cardCode: cardCode,
				ID: docEntry,
				draft: !!isDraft,
			}).then(res => {
				let stateData = {
					order: {
						...initialState.order,
						...res.payload.header,
						ShipTo: '',
						BillTo: '',
						ActualShipTo: res.payload.header.ShipTo,
						ActualBillTo: res.payload.header.BillTo,
					},
					loadingOrder: false,
					pageError: false,
					isQuote: false,
					isDraft: !!isDraft,
					submitAction: isDraft ? 'saveDraft' : 'save',
					freight: { ...initialState.freight, ...res.payload.freight },
					deletedLines: [],
					showPrintDialog: state.showPrintDialogOnLoad,
					showPrintDialogOnLoad: false,
					showForcedDraftDialog: state.showForcedDraftDialog,
					showSlowPokeDialog: false,
				};

				let warehouses = [ ...state.warehouses ];
				let lines = res.payload.lines || [];

				for ( let i = 0; i < lines.length; i++ ) {
					if ( warehouses.indexOf(lines[ i ].WhsCode) === -1 ) {
						warehouses.push(lines[ i ].WhsCode);
					}
				}

				stateData.warehouses = warehouses;

				if ( res.payload.header.Status !== 'O' ) {
					stateData.submitAction = 'duplicate';
				}

				dispatch({
					type: types.SET_STATE,
					data: stateData,
				});
				dispatch({ type: lineTypes.RESET_ALL });
				dispatch({
					type: lineTypes.UPDATE_LINE,
					data: lines,
					lineID: 0,
				});
				dispatch(actions.updateTotals());
			}).catch(err => {
				let stateData = {
					order: { ...initialState.order },
					loadingOrder: false,
					pageError: true,
					isQuote: false,
					isDraft: !!isDraft,
				};

				dispatch({
					type: types.SET_STATE,
					data: stateData,
				});
				dispatch({
					type: layoutTypes.NOTIFY,
					text: 'Error loading document',
				});
			});
		};
	},


	loadQuote: (cardCode, docEntry, isDraft = false) => {
		return (dispatch, getState) => {
			let state = getState().salesOrders;
			let newState = {
				...initialState,
				mode: state.mode,
				isQuote: state.isQuote,
				isDraft: state.isDraft,
				loadingOrder: true,
				DocEntry: state.DocEntry,
				cardCode: state.cardCode,
			};

			dispatch({
				type: types.SET_STATE,
				data: newState,
			});
			dispatch({ type: lineTypes.RESET_ALL });

			svc.send('salesquote', {
				method: 'load',
				cardCode: cardCode,
				ID: docEntry,
				draft: !!isDraft,
			}).then(res => {
				let stateData = {
					order: {
						...state.order,
						...res.payload.header,
						ShipTo: '',
						BillTo: '',
						ActualShipTo: res.payload.header.ShipTo,
						ActualBillTo: res.payload.header.BillTo,
					},
					loadingOrder: false,
					pageError: false,
					isQuote: true,
					isDraft: !!isDraft,
					submitAction: isDraft ? 'saveDraft' : 'save',
					freight: { ...state.freight, ...res.payload.freight },
					quoteUDFs: { ...state.quoteUDFs },
					deletedLines: [],
					showPrintDialog: state.showPrintDialogOnLoad,
					showPrintDialogOnLoad: false,
					showSlowPokeDialog: false,
				};

				let warehouses = [ ...state.warehouses ];
				let lines = res.payload.lines || [];

				for ( let i = 0; i < lines.length; i++ ) {
					if ( warehouses.indexOf(lines[ i ].WhsCode) === -1 ) {
						warehouses.push(lines[ i ].WhsCode);
					}
				}

				stateData.warehouses = warehouses;

				if ( res.payload.header.Status !== 'O' ) {
					stateData.submitAction = 'duplicate';
				}

				for ( let quoteKey in state.quoteUDFs ) {
					if ( stateData.order.hasOwnProperty(quoteKey) ) {
						stateData.quoteUDFs[ quoteKey ] = stateData.order[ quoteKey ];
						delete stateData.order[ quoteKey ];
					}
				}

				dispatch({
					type: types.SET_STATE,
					data: stateData,
				});
				dispatch({ type: lineTypes.RESET_ALL });
				dispatch({
					type: lineTypes.UPDATE_LINE,
					data: res.payload.lines,
					lineID: 0,
				});
				dispatch(actions.updateTotals());
			}).catch(err => {
				let stateData = {
					order: { ...initialState.order },
					loadingOrder: false,
					pageError: true,
					isQuote: true,
					isDraft: !!isDraft,
				};

				dispatch({
					type: types.SET_STATE,
					data: stateData,
				});
				dispatch({
					type: layoutTypes.NOTIFY,
					text: 'Error loading document',
				});
			});
		};
	},


	copyDocument: () => {
		return (dispatch, getState) => {
			let state = getState().salesOrders;
			let { DocEntry, DocNum, Key, ...order } = { ...state.order };
			//let isDraft = state.isDraft;
			let extras = {
				Status: 'O',
				CANCELED: 'N',
				PostingDate: getDate(),
				DueDate: getDate(),
				DocumentDate: getDate(),
				Printed: 'N',
				U_TSPayflowID: '',
				ShipTo: state.order.ShipTo,
				BillTo: state.order.BillTo,
				BaseCard: '',
				BaseRef: '',
				BaseType: '',
				TargetType: '',
				TargetEntry: '',
			};

			svc.send('document', {
				method: 'copy',
				save: false,
				sourceType: 'quote',
				sourceKey: DocEntry,
				cardCode: order.CardCode,
				targetType: 'order',
				extras: extras,
			}).then(res => {
				let stateData = {
					order: {
						...state.order,
						...res.payload.header,
					},
					mode: 'new',
					hasChanged: true,
					loadingOrder: false,
					pageError: false,
					isQuote: false,
					isDraft: false,
					submitAction: 'save',
					freight: { ...state.freight, ...res.payload.freight },
					quoteUDFs: { ...state.quoteUDFs },
					deletedLines: [],
					showPrintDialog: false,
					showPrintDialogOnLoad: false,
					showSlowPokeDialog: false,
					DocEntry: null,
				};

				let warehouses = [ ...state.warehouses ];
				let lines = res.payload.lines || [];

				for ( let i = 0; i < lines.length; i++ ) {
					if ( warehouses.indexOf(lines[ i ].WhsCode) === -1 ) {
						warehouses.push(lines[ i ].WhsCode);
					}
				}

				stateData.warehouses = warehouses;

				dispatch({
					type: types.SET_STATE,
					data: stateData,
				});
				dispatch({ type: lineTypes.RESET_ALL });
				dispatch({
					type: lineTypes.UPDATE_LINE,
					data: res.payload.lines,
					lineID: 0,
				});
				dispatch(actions.updateTotals());
				dispatch({
					type: layoutTypes.NOTIFY,
					text: `Copied document.`,
				});

			}).catch(err => {
				dispatch({
					type: layoutTypes.NOTIFY,
					text: err.msg,
				});
			});
		}
	},



	duplicate: () => {
		return (dispatch, getState) => {
			let state = getState();
			let { DocEntry, DocNum, Key, ...order } = { ...state.salesOrders.order };
			let isDraft = state.salesOrders.isDraft;
			let isQuote = state.salesOrders.isQuote;

			let lines = state.salesorderLines.map(line => {
				let newLine = {
					...line,
					Key: '',
					LineStatus: 'O',
					UnitPrice: line.BasePrice,
					SalesEmployeeCode: state.businessPartners.bp.SlpCode,
				};
				delete(newLine.Key);
				return newLine;
			});

			let update = {
				hasChanged: true,
				DocEntry: '',
				mode: 'new',
				submitAction: !!isDraft ? 'saveDraft' : 'save',
				showPrintDialog: false,
				showPrintDialogOnLoad: false,
				order: {
					...order,
					DocNum: null,
					DocEntry: null,
					Status: 'O',
					CANCELED: 'N',
					PostingDate: getDate(),
					DueDate: getDate(),
					DocumentDate: getDate(),
					Printed: 'N',
					U_TSPayflowID: '',
					ShipTo: order.ActualShipTo,
					BillTo: order.ActualBillTo,
					BaseCard: '',
					BaseRef: '',
					BaseType: '',
					TargetType: '',
					TargetEntry: '',
					SalesEmployeeCode: state.businessPartners.bp.SlpCode,
				},
			};

			dispatch({
				type: types.SET_STATE,
				data: update,
			});
			dispatch({ type: lineTypes.RESET_ALL });
			dispatch({
				type: lineTypes.REPLACE_STATE,
				data: lines,
			});
			dispatch({
				type: layoutTypes.NOTIFY,
				text: `${isQuote ? 'Quote' : 'Order'} Duplicated.`,
			});

			let shipData = {}, billData = {};
			let shipIndex = findIndex(state.businessPartners.addresses.shipping, { ID: order.ActualShipTo });
			let billIndex = findIndex(state.businessPartners.addresses.billing, { ID: order.ActualBillTo });

			if ( shipIndex !== -1 ) {
				shipData = state.businessPartners.addresses.shipping[ shipIndex ];
			}
			if ( billIndex !== -1 ) {
				billData = state.businessPartners.addresses.billing[ billIndex ];
			}

			dispatch(actions.setAddress('shipping', shipData));
			dispatch(actions.setAddress('billing', billData));
		}
	},


	saveOrder: () => {
		return (dispatch, getState) => {
			let state = getState();
			let isQuote = state.salesOrders.isQuote;
			let isDraft = !!state.salesOrders.isDraft;
			let actionType = isQuote ? 'salesquote' : 'salesorder';
			let orderKey = isQuote ? 'quote' : 'order';

			if ( Number(state.salesOrders.order.DiscountByPercent) < -0.1
				|| Number(state.salesOrders.order.DiscountByAmount) < -0.01 ) {
				dispatch({
					type: layoutTypes.NOTIFY,
					text: `Discount cannot be negative`,
				});
				return false;
			}

			let deletedLines = state.salesOrders.deletedLines.map(deleted => {
				return {
					Key: deleted,
					Delete: true,
				};
			});
			let regularLines = state.salesorderLines.filter(line => {
				return ((line.removable || line.Key) && line.LineStatus !== 'C')
			});
			let kitLines = state.salesorderLines.filter(line => {
				return (line.childCount > 0 && (line.Key === '' || line.Key === null))
			});

			let order;
			if ( isQuote ) {
				order = { ...state.salesOrders.order, ...state.salesOrders.quoteUDFs };
			} else {
				order = { ...state.salesOrders.order };
				// Delete quote UDFs, we don't want to save those
				for ( let key in state.salesOrders.quoteUDFs ) {
					delete(order[ key ]);
				}
			}

			// Let's also delete any of the image columns...
			for ( let i = 0; i < state.salesOrders.imageColumns.length; i++ ) {
				let key = state.salesOrders.imageColumns[ i ];
				delete(order[ key ]);
			}

			// Aaaaand update the ATTN: address fields
			if ( order.attnShip ) {
				order[ `ShipStreet` ] = `${order.attnShip}\n${order.ShipStreet}`.trim();
			}
			if ( order.attnBill ) {
				order[ `BillStreet` ] = `${order.attnBill}\n${order.BillStreet}`.trim();
			}

			// Set payment terms to credit card manual if CC payment has been taken
			if ( !isQuote && !isDraft && !order.DocEntry && order.U_TSPayflowID ) {
				order.GroupNum = 11;
			}

			let payload = {
				method: 'save',
				data: {
					[ orderKey ]: order,
					lines: [ ...regularLines, ...deletedLines ],
					draft: isDraft,
					freight: state.salesOrders.freight,
				},
			};

			dispatch({
				type: layoutTypes.NOTIFY,
				text: `Saving Document`,
			});
			dispatch({
				type: types.SET_STATE,
				data: {
					pendingSave: true,
					showSlowPokeDialog: (kitLines.length > 3),
				},
			});

			svc.send(actionType, payload).then(res => {
				let update = {
					hasChanged: false,
					mode: 'edit',
					DocEntry: res.payload.Key,
					loadingOrder: false,
					order: {
						...state.salesOrders.order,
						Key: res.payload.Key,
					},
					isQuote: isQuote,
					pendingSave: false,
					isDraft: res.payload.forcedDraft ? true : isDraft,
					showSaveDialog: false,
					skipPayment: false,
					showForcedDraftDialog: !!res.payload.forcedDraft,
					showPrintDialog: false,
					showPrintDialogOnLoad: (!isQuote && !isDraft && !res.payload.forcedDraft),
					deletedLines: [],
				};

				dispatch({
					type: types.SET_STATE,
					data: update,
				});
				dispatch({
					type: layoutTypes.NOTIFY,
					text: `Saved Document`,
				});

				if ( state.salesOrders.isQuote ) {
					dispatch(actions.loadQuote(state.businessPartners.bp.Code, res.payload.Key, update.isDraft));
				} else {
					dispatch(actions.loadOrder(state.businessPartners.bp.Code, res.payload.Key, update.isDraft));
				}
			}).catch(err => {
				console.error(err);
				dispatch({
					type: layoutTypes.NOTIFY,
					text: err.msg,
				});
				dispatch({
					type: types.SET_STATE,
					data: {
						pendingSave: false,
						showSaveDialog: false,
						saveErrors: err.msg,
					},
				});
			});
		}
	},


	updateTotals: () => {
		return (dispatch, getState) => {
			let state = getState();
			let lines = state.salesorderLines;
			let so = state.salesOrders;
			let freight = state.salesOrders.freight;

			let docDiscount = 1 - ((Number(so.order.DiscountByPercent) || 0) / 100);
			let totalBeforeLineDiscounts = sum(lines.map(line => {
				return Number((line.BasePrice || 0)) * Number((line.Qty || 0));
			}));

			let freightAmount = 0;

			for ( let key in freight ) {
				freightAmount += Number(freight[ key ].LineTotal);
			}

			let totalAfterLineDiscounts = sum(lines.map(line => {
				return Number((line.LineTotal || 0));
			}));

			let taxAmount = calculateTax(state);
			let DocTotal = ((Number(taxAmount) + ((totalAfterLineDiscounts * docDiscount) || 0)) + freightAmount).toFixed(2);
			let DiscountTotal = Number((totalBeforeLineDiscounts - DocTotal + taxAmount + freightAmount).toFixed(2));
			let DiscountByAmount = Number((Number((totalAfterLineDiscounts || 0)) * ((Number(so.order.DiscountByPercent) || 0) / 100)).toFixed(2));

			let update = {
				order: {
					...so.order,
					totalBeforeLineDiscounts: totalBeforeLineDiscounts.toFixed(2),
					totalAfterLineDiscounts: totalAfterLineDiscounts.toFixed(2),
					taxAmount,
					DocTotal,
					DiscountTotal,
					DiscountByAmount,
				},
			};

			dispatch({
				type: types.SET_STATE,
				data: update,
			});
		}
	},


};



function calculateTax(state) {
	let appData = state.appData;
	let lines = state.salesorderLines;
	let so = state.salesOrders;
	let freight = state.salesOrders.freight;
	let skipTax = state.businessPartners.bp.TaxStatus === 'N';

	let taxTotal = 0;

	let docDiscount = (Number(so.order.DiscountByPercent) || 0) / 100;

	// Sum up line taxes
	let lineTaxes = lines.map(line => {
		if(line.TaxStatus === 'N') return 0;
		let lineTaxCode = line.TaxCode || 'UPDATE';
		let taxIndex = appData.TaxCodeLookup[ lineTaxCode ];
		let taxRate = skipTax ? 0 : appData.TaxCodes[ taxIndex ].rate;
		let tax = (Number(line.LineTotal) * (1 - docDiscount)) * (Number(taxRate) / 100);

		return roundUp(tax, 2);
	});
	taxTotal += sum(lineTaxes);

	for ( let key in freight ) {
		let line = freight[ key ];
		let lineTaxCode = line.TaxCode || 'UPDATE';
		let taxIndex = appData.TaxCodeLookup[ lineTaxCode ];

		if ( appData.TaxCodes[ taxIndex ].freight === 'Y' ) {
			let taxRate = skipTax ? 0 : appData.TaxCodes[ taxIndex ].rate;
			taxTotal += Number(freight[ key ].LineTotal) * Number(taxRate / 100);
		}
	}

	return Number(taxTotal.toFixed(2));
}


function roundUp(num, precision) {
	precision = Math.pow(10, precision);
	return Math.ceil(num * precision) / precision
}

/*
 function roundDown(num, precision) {
 precision = Math.pow(10, precision);
 return Math.floor(num * precision) / precision
 }
 */

function getDate(addDays = 0) {
	let now = new Date();
	let adjusted = new Date(now);
	adjusted.setDate(adjusted.getDate() + addDays);

	let dd = adjusted.getDate();
	let mm = adjusted.getMonth() + 1; //January is 0!
	let yyyy = adjusted.getFullYear();

	if ( dd < 10 ) {
		dd = '0' + dd;
	}
	if ( mm < 10 ) {
		mm = '0' + mm;
	}

	return `${yyyy}-${mm}-${dd}`;
}